import { ActionIcon, Avatar, Badge, Group, Indicator, Menu, Text, Tooltip } from '@mantine/core';
import { IconLogout, IconSettings, IconUserCircle } from '@tabler/icons-react';
import { useLocation } from 'wouter';
import { paths } from '../../app/routes';
import { useAccount } from './AccountProvider';
import { Copy } from '../../ui/Brand';

/** Header: who's signed in (initials), with a menu to sign out. Signed out: a quiet icon that leads to Settings. */
export const AccountButton = () => {
  const { state, signOut } = useAccount();
  const [, navigate] = useLocation();
  if (state.status === 'disabled' || state.status === 'loading') return null;
  if (state.status !== 'signedIn') {
    return (
      <Tooltip label={state.status === 'unavailable' ? "Can't reach sign-in (offline?)" : 'Not signed in'}>
        <ActionIcon size="lg" aria-label="Account" onClick={() => navigate(paths.settings('account'))} data-testid="account-button">
          <IconUserCircle size={18} />
        </ActionIcon>
      </Tooltip>
    );
  }
  const who = state.user?.name ?? state.user?.email ?? 'Signed in';
  return (
    <Menu position="bottom-end" width={240}>
      <Menu.Target>
        <ActionIcon size="lg" variant="subtle" radius="xl" aria-label={`Account: ${who}`} data-testid="account-button">
          <Indicator disabled={!state.problem} color="yellow" size={8} offset={3}>
            <Avatar size={26} radius="xl" color="initials" name={who} />
          </Indicator>
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>
          <Group gap={6} wrap="nowrap">
            <Text size="sm" fw={600} c="var(--mantine-color-text)" truncate>{who}</Text>
            {state.user?.role === 'admin' && <Badge size="xs" variant="light">admin</Badge>}
          </Group>
          {state.user && <Text size="xs" truncate>{state.user.email}</Text>}
          {state.problem && <Text size="xs" c="yellow.8" mt={4}><Copy>{state.problem}</Copy></Text>}
        </Menu.Label>
        <Menu.Divider />
        <Menu.Item leftSection={<IconSettings size={14} />} onClick={() => navigate(paths.settings('account'))}>Account settings</Menu.Item>
        <Menu.Item leftSection={<IconLogout size={14} />} onClick={() => void signOut()}>Sign out</Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
